import { COMMAND_DECK_PREVIEW_BANNER } from '../config/commandDeckMvp'

export function PreviewBanner() {
  return (
    <div className="command-deck-banner" role="status">
      {COMMAND_DECK_PREVIEW_BANNER}
    </div>
  )
}
